// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.requestCard {
  overflow: hidden;
}

.requestCard:hover {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  cursor: pointer;
}

.cardDateContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
.cardTypeBox {
  width: 85px;
  text-align: center;
  font-weight: 600;
  border-radius: 5px;
  padding: 5px 5px;
  font-size: 10px;
  line-height: 1.3;
  text-transform: uppercase;
  display: inline-flex;
  justify-content: center;
}

.hire {
  background-color: #0d6efd;
  color: #fff;
}

.swap {
  background-color: #ffc107;
}

.hireOrSwap {
  background-color: #157347;
  color: #fff;
}

.sale {
  background-color: #dc3545;
  color: #fff;
}

.sold {
  background-color: #6c757d;
  color: #fff;
}
.bearth-content-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  font-size: 14px;
  gap: 15px;
}
.bearth-content-row:last-child {
  margin-bottom: 0px;
}
.bearth-title {
  font-size: 20px !important;
  font-weight: 500 !important;
}
.left-data {
  width: 50%;
}
.right-data {
  width: 50%;
  text-align: right;
  display: flex;
  justify-content: end;
}`, "",{"version":3,"sources":["webpack://./src/components/card/Card.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,4EAA4E;EAC5E,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;AACA;EACE,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,aAAa;EACb,oBAAoB;AACtB","sourcesContent":[".requestCard {\n  overflow: hidden;\n}\n\n.requestCard:hover {\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n  cursor: pointer;\n}\n\n.cardDateContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n}\n.cardTypeBox {\n  width: 85px;\n  text-align: center;\n  font-weight: 600;\n  border-radius: 5px;\n  padding: 5px 5px;\n  font-size: 10px;\n  line-height: 1.3;\n  text-transform: uppercase;\n  display: inline-flex;\n  justify-content: center;\n}\n\n.hire {\n  background-color: #0d6efd;\n  color: #fff;\n}\n\n.swap {\n  background-color: #ffc107;\n}\n\n.hireOrSwap {\n  background-color: #157347;\n  color: #fff;\n}\n\n.sale {\n  background-color: #dc3545;\n  color: #fff;\n}\n\n.sold {\n  background-color: #6c757d;\n  color: #fff;\n}\n.bearth-content-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 10px;\n  font-size: 14px;\n  gap: 15px;\n}\n.bearth-content-row:last-child {\n  margin-bottom: 0px;\n}\n.bearth-title {\n  font-size: 20px !important;\n  font-weight: 500 !important;\n}\n.left-data {\n  width: 50%;\n}\n.right-data {\n  width: 50%;\n  text-align: right;\n  display: flex;\n  justify-content: end;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
